import React from 'react';
import transcript_logo from '../../../assets/Frame(2).png';

const TranscriptPanel = ({ isMobile, transcriptData, transcriptEndRef }) => {
  const containerStyles = isMobile
    ? {
        width: '100%',
        height: isMobile ? '35vh' : '100%',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        margin: '0',
        marginBottom: '0',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }
    : {
        background: '#fff',
        height: '100%', // Take full height of parent
        width: '100%', // Take full width of parent
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 99,
        color: '#000',
        overflow: 'hidden'
      };

  const headerStyles = {
    padding: isMobile ? '8px 12px' : '16px 20px',
    borderBottom: '1px solid #EAECF0',
    display: 'flex',
    alignItems: 'center',
    gap: isMobile ? '8px' : '12px',
    flexShrink: 0
  };

  const titleStyles = {
    fontSize: isMobile ? '14px' : '18px',
    fontWeight: '500',
    color: isMobile ? '#676767' : '#111827'
  };

  const contentStyles = {
    overflowY: 'auto',
    height: isMobile ? 'calc(100% - 40px)' : 'calc(90vh - 40px)',
    padding: isMobile ? '8px' : '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: isMobile ? '10px' : '24px',
    flex: 1,
    WebkitOverflowScrolling: 'touch'
  };

  return (
    <div style={containerStyles}>
      <div style={headerStyles}>
        <img 
          src={transcript_logo} 
          alt="PromptHire" 
          style={{ width: isMobile ? '20px' : '24px', height: isMobile ? '20px' : '24px' }} 
        />
        <p style={titleStyles}>PromptHire Transcript</p>
      </div>
      
      <div style={contentStyles}>
        {transcriptData.length === 0 ? (
          <div 
            onCopy={(e) => e.preventDefault()} 
            style={{
              color: '#6B7280',
              textAlign: 'center',
              padding: '20px'
            }}
          >
            Waiting for transcript...
          </div>
        ) : (
          transcriptData.map((item, index) => (
            <TranscriptItem 
              key={`transcript-${item.timestamp || Date.now()}-${index}`}
              item={item} 
              index={index} 
              isMobile={isMobile} 
            />
          )).concat(
            <div key="transcript-end" ref={transcriptEndRef} />
          )
        )}
      </div>
    </div>
  );
};

// Sub-component for individual transcript items
const TranscriptItem = ({ item, index, isMobile }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '6px' : '8px' }}>
      {index > 0 && index % 3 === 0 && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: isMobile ? '2px' : '4px'
        }}>
          <div style={{
            width: isMobile ? '28px' : '32px',
            height: isMobile ? '28px' : '32px',
            borderRadius: '50%',
            background: '#FFF4ED',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{ color: '#FF5C00' }}>★</span>
          </div>
          <span style={{
            color: '#FF5C00',
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: '500'
          }}>INTERVIEWER</span>
        </div>
      )}
      
      <div 
        onCopy={(e) => e.preventDefault()} 
        style={{
          background: '#fff',
          padding: isMobile ? '12px' : '16px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          border: '1px solid #EAECF0',
          color: '#111827',
          fontSize: isMobile ? '14px' : '16px',
          lineHeight: '1.5'
        }}
      >
        {item.message}
      </div>
      
      {index > 0 && index % 3 === 0 && (
        <span style={{
          color: '#6B7280',
          fontSize: isMobile ? '12px' : '14px',
          marginTop: isMobile ? '2px' : '4px'
        }}>
          {new Date().toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
          })}
        </span>
      )}
    </div>
  );
};

export default TranscriptPanel;